module.exports = __webpack_public_path__ + "img/QLD-Back.6c91e244.png";